export const translations = {
  // Common
  home: 'Home',
  shop: 'Shop',
  about: 'About',
  contact: 'Contact',
  cart: 'Cart',
  language: 'Language',
  currency: 'EGP',
  
  // Announcement
  welcomeMessage: 'Welcome to Mohamed Hassan Amin Company',
  freeShipping: 'Free shipping on qualifying orders',
  
  // Products
  ourProducts: 'Our Products',
  discoverProducts: 'Discover our wide range of quality products',
  searchProducts: 'Search products...',
  allCategories: 'All Categories',
  allBrands: 'All Brands',
  showing: 'Showing',
  showingResults: 'Showing',
  noProductsFound: 'No products found',
  previous: 'Previous',
  next: 'Next',
  of: 'of',
  products: 'products',
  product: 'product',
  addToCart: 'Add To Cart',
  viewCart: 'View Cart',
  inStock: 'In Stock',
  outOfStock: 'Out of Stock',
  quickView: 'Quick View',
  wishlist: 'Wishlist',
  noImage: 'No Image',
  sortBy: 'Sort By',
  defaultSort: 'Default',
  priceLowToHigh: 'Price: Low to High',
  priceHighToLow: 'Price: High to Low',
  onSale: 'On Sale',
  filters: 'Filters',
  allProducts: 'All Products',
  discountedOnly: 'Discounted Only',
  
  // Cart
  shoppingCart: 'Shopping Cart',
  reviewItems: 'Review your items and proceed to checkout',
  yourCartEmpty: 'Your cart is empty',
  continueShopping: 'Continue Shopping',
  clearCart: 'Clear Cart',
  cartSummary: 'Cart Summary',
  items: 'Items',
  total: 'Total',
  unitPrice: 'Unit Price',
  quantity: 'Quantity',
  subtotal: 'Subtotal',
  shipping: 'Shipping',
  discount: 'Discount',
  tax: 'Tax',
  free: 'Free',
  city: 'City',
  selectCity: 'Select City',
  promoCode: 'Promo Code',
  enterPromoCode: 'Enter promo code',
  apply: 'Apply',
  promoCodeApplied: 'Promo code applied!',
  offApplied: 'OFF applied!',
  paymentMethod: 'Payment Method',
  cardPayment: 'Visa / Mastercard / Apple Pay',
  cashOnDelivery: 'Cash on Delivery / Instapay',
  instapayCashOnDelivery: 'Instapay / Cash on Delivery',
  visaApplePay: 'Visa / Apple Pay',
  visa: 'Visa',
  securedByPaymob: 'Secured by Paymob',
  applePay: 'Apple Pay',
  cash: 'Cash',
  instapay: 'Instapay',
  placeOrder: 'Place Order',
  remove: 'Remove',
  proceedToCheckout: 'Proceed to Checkout',
  
  // Checkout
  checkout: 'Checkout',
  completeOrder: 'Complete your order details',
  shippingInformation: 'Shipping Information',
  fullName: 'Full Name',
  email: 'Email',
  phone: 'Phone',
  phoneNumberLabel: 'Phone Number',
  shippingAddress: 'Shipping Address',
  enterFullName: 'Enter your full name',
  enterEmail: 'Enter your email',
  enterPhone: 'Enter your phone number',
  enterShippingAddress: 'Enter your shipping address',
  proceedToPayment: 'Proceed to Payment',
  processing: 'Processing...',
  orderSummary: 'Order Summary',
  
  // Payment
  paymentSuccessful: 'Payment Successful!',
  orderSuccessful: 'Order Successful!',
  paymentFailed: 'Payment Failed',
  paymentPending: 'Payment Pending',
  thankYouOrder: 'Thank you for your order. Your payment has been processed successfully.',
  paymentNotProcessed: 'Unfortunately, your payment could not be processed. Please try again.',
  paymentProcessing: 'Please wait while we process your payment...',
  processingPayment: 'Processing your payment...',
  orderDetails: 'Order Details',
  orderNumber: 'Order Number',
  totalAmount: 'Total Amount',
  status: 'Status',
  orderShipped: 'Order will ship within 3 working days',
  backToCart: 'Back to Cart',
  orderConfirmed: 'Your order has been confirmed and will be processed shortly.',
  printOrder: 'Download Order',
  
  // Footer
  designedBy: 'Designed & Created By',
  taxNumber: 'Tax Number: 232446768',
  copyright: 'Copyright',
  allRightsReserved: 'All rights reserved',
  websiteDesignedBy: 'Website Is Designed & Created By',
  
  // Info Popup
  contactUs: 'Contact Us',
  address: 'Address',
  companyAddress: '9 Abdel Hakk El Sonbati St., Opera Sq',
  companyCityCountry: 'Cairo - Egypt',
  phoneNumber: '+20 12 29009073',
  emailAddress: 'mohamedhassanamin.co@gmail.com',
  
  // Contact Page
  contactSubtitle: 'Get in touch with us',
  ourAddress: 'Our Address',
  location: 'Location',
  getInTouch: 'Get In Touch',
  yourName: 'Your Name',
  yourEmail: 'Your Email',
  yourPhone: 'Your Phone Number',
  subject: 'Subject',
  yourMessage: 'Your Message',
  sendMessage: 'Send Message',
  contactFormSuccess: 'Thank you for your message! We will get back to you soon.',
  findUs: 'Find Us',
  viewOnMap: 'View our location on Google Maps',
  openInGoogleMaps: 'Open in Google Maps',
  
  // About Page
  aboutUs: 'About Us',
  aboutSubtitle: 'Learn more about our company',
  welcomeToCompany: 'Welcome To',
  companyName: 'Mohamed Hassan Amin Company',
  companyFullName: 'Mohamed Hassan Amin Company',
  aboutDescription1: 'Mohamed Hassan Amin Company is a leading provider of quality products and services. We are committed to delivering excellence and building lasting relationships with our customers.',
  aboutDescription2: 'With years of experience in the industry, we have established ourselves as a trusted partner for businesses and individuals seeking high-quality solutions. Our team is dedicated to providing exceptional service and support.',
  companyProfile: 'Company Profile',
  downloadProfile: 'Download Company Profile',
  companyProfileDescription: 'Download our comprehensive company profile to learn more about our history, mission, values, and the quality products and services we offer.',
  installApp: 'Install App',
  installAppTitle: 'Get Our App',
  installAppDesc: 'Install our app for faster access, offline browsing, and instant notifications for the latest offers and products.',
  installAppBtn: 'Install App',
  installAppIosStep1: 'Tap the Share button below',
  installAppIosStep2: 'Tap "Add to Home Screen"',
  installAppIosLabel: 'To install on iPhone:',
  estIn1972: 'EST in 1972',
  shopNow: 'Shop Now',
  bestProduct: 'Best Product',
  bestQuality: 'Best Quality Products',
  fastDelivery: 'Fast Delivery',
  fastDeliveryDesc: 'Quick and Reliable Shipping',
  securePayment: 'Secure Payment',
  securePaymentDesc: 'Safe and Secure Transactions',
  customerSupport: '24/7 Support',
  customerSupportDesc: 'Always Here to Help',
  
  // Categories
  ourCategories: 'Our Categories',
  discoverCategories: 'Explore our product categories',
  
  // Brands
  ourBrands: 'Our Brands',
  browseBrands: 'Browse products by brand',
  
  // Latest News
  latestNews: 'Latest News',
  stayUpdated: 'Stay updated with our latest updates and announcements',
  
  // Product Detail
  productCatalog: 'Product Catalog',
  downloadCatalog: 'Download Catalog',
  downloadPdf: 'Download PDF',
  
  // Errors
  errorOccurred: 'An error occurred',
  tryAgain: 'Please try again later',
  
  // Toast Messages
  productAddedToCart: 'added to cart!',
  selectAllRequiredOptions: 'Please select all required options',
  productSavedSuccessfully: 'Product saved successfully!',
  optionAddedSuccessfully: 'Option added successfully',
  optionDeletedSuccessfully: 'Option deleted successfully',
  valueAddedSuccessfully: 'Value added successfully',
  valueDeletedSuccessfully: 'Value deleted successfully',
  markedAsReadSuccessfully: 'Marked as read successfully',
  submissionDeletedSuccessfully: 'Submission deleted successfully',
  orderMarkedAsRead: 'Order marked as read',
  deliveredStatusUpdated: 'Delivered status updated',
  statusSetToSuccess: ' and status set to Success',
  statusUpdatedSuccessfully: 'Status updated successfully',
  paymentMethodUpdated: 'Payment method updated',
  orderStatusUpdatedSuccessfully: 'Order status updated successfully',
  contactSettingsSavedSuccessfully: 'Contact settings saved successfully',
  failedToLoad: 'Failed to load',
  failedToSave: 'Failed to save',
  failedToDelete: 'Failed to delete',
  failedToUpdate: 'Failed to update',
  pleaseSaveProductFirst: 'Please save the product first before adding options',
  errorProcessingCheckout: 'Error processing checkout',

  // App update banner (PWA)
  updateAvailable: 'Update available',
  updateAvailableDesc: 'A new version of the store is ready. Refresh whenever you like.',
  refresh: 'Refresh',
  updating: 'Updating...',
  later: 'Later',

  // Not found states
  pageNotFoundTitle: 'Page not found',
  pageNotFoundDesc: 'The page you are looking for does not exist or has been moved.',
  backToHome: 'Back to Home',
  browseProducts: 'Browse Products',
  productNotFound: 'Product not found',
  productNotFoundDesc: 'This product is not available or no longer exists.',

  // Loading / stock
  loading: 'Loading...',
  onlyNAvailable: 'Only {n} available in stock',
  freeShippingGeneric: 'Free shipping on qualifying orders',
  freeShippingOverAmount: 'Free Shipping Over {amount} EGP',

  // Instapay instructions on the order success page (stream A handoff)
  instapayInstructionsTitle: 'Instapay payment',
  instapayInstructions: 'We will contact you on your phone or email with the transfer details. Please use your order number as the transfer reference. Your order is confirmed once the payment is received.',

  // Contact form validation
  nameTooShort: 'Name must be at least 2 characters.',
  invalidEmail: 'Please enter a valid email address.',
  invalidPhone: 'Please enter a valid phone number.',
  messageTooShort: 'Message must be at least 10 characters.',
  contactFormFailed: 'Failed to send message. Please try again.',
  connectionError: 'Unable to connect to server. Please check your connection and try again.',
};
